// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fp","advertDetailContactGroup__header":"c-n_fq","advertDetailContactGroup__value":"c-n_fr"};